import { useTranslation } from 'react-i18next';

import { closeDialog, openDialog } from 'components/dialog/modalSlice';
import InfoDialog from 'components/dialog/templates/InfoDialog';
import { useAppSelector, useAppDispatch } from 'hooks';
import HideComponent from 'components/HideComponent';
import { Permissions } from 'entities/dashboard';
import Loading from 'components/Loading';

import { getApiAccounts, getIsLoading } from './selectors';
import DropdownMenu from '../Connectors/DropdownMenu';
import { viewApiAccount } from './accountingSlice';

const ApiCredentialsList = () => {
  const { t } = useTranslation('integration');
  const dispatch = useAppDispatch();

  const isLoading = useAppSelector(getIsLoading);
  const apiAccounts = useAppSelector(getApiAccounts);

  const HandleDisconnect = () => {
    dispatch(
      openDialog({
        title: t('integration:api.disconnectTitle'),
        maxWidth: '512px',
        content: (
          <InfoDialog
            text={t('integration:api.disconnectTitle')}
            onClose={() => dispatch(closeDialog())}
            onConfirm={() => dispatch(closeDialog())}
          />
        ),
      }),
    );
  };

  return (
    <div className="table w-full mt-6">
      <div className="table-header-group">
        <div className="table-row uppercase font-medium text-xs text-gray-500">
          <div className="table-cell px-4 py-3">
            {t('integration:api.clientId')}
          </div>
          <div className="table-cell w-8 px-4 py-3"></div>
        </div>
      </div>
      <div className="table-row-group">
        <HideComponent show={isLoading}>
          <Loading zIndex={10} transparent />
        </HideComponent>
        {apiAccounts.map((account) => (
          <div key={account.applicationId} className="table-row">
            <div className="table-cell p-4 border-t border-gray-200 text-sm font-medium">
              {account.applicationId}
            </div>
            <div className="table-cell border-t border-gray-200">
              <DropdownMenu
                permission={Permissions.erpIntegration}
                onUpdate={() => dispatch(viewApiAccount(account))}
                onDisconnect={HandleDisconnect}
                onRefresh={null}
                onConnect={null}
                isActive={true}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ApiCredentialsList;
